import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCallback, useId, useMemo, useState, } from 'preact/compat';
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { defaultProps } from '@widgets/MiscProducts/types/config';
import MiscCard from '@widgets/MiscProducts/components/MiscCard';
import Notice from '@widgets/shared/components/Notice';
import { FormProvider, useForm, } from 'react-hook-form';
import { miscProductsSchema } from '@widgets/MiscProducts/validation/schema';
import { yupResolver } from '@hookform/resolvers/yup';
import Band from '@genericBookings/components/AttendeesSelector/components/Band';
import NumberInput from '@widgets/shared/components/NumberInput';
import API from '@widgets/shared/API/connection';
import convertBasketProductPriceBandsToGenericBands from '@widgets/shared/convertBasketProductPriceBandsToGenericBands';
import { BandsList, Wrapper } from './styles';
function Component({ items, redirect: localRedirect }) {
    const formKey = useId();
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(miscProductsSchema),
        defaultValues: {},
    });
    const { watch, getValues, setValue, formState: { errors, isValid }, } = form;
    const [selectedItem, setSelectedItem] = useState(undefined);
    const [modalVisible, setModalVisible] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const genericBands = useMemo(() => (!selectedItem ? [] : convertBasketProductPriceBandsToGenericBands(selectedItem.PriceBands)), [selectedItem]);
    // @ts-ignore
    const units = watch([...Array(9).fill(0).map((_, idx) => `PriceBands.${idx}.Units`)]);
    const total = useMemo(() => (units.reduce((carry, unit) => carry + (unit ?? 0), 0)), [units]);
    const formSubmittable = useMemo(() => !isSubmitting && isValid && total > 0, [total, isValid, isSubmitting]);
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        if (!selectedItem) {
            return;
        }
        setIsSubmitting(true);
        Promise.all(selectedItem.PriceBands.map((_, idx) => API.adjustMiscProductQty(selectedItem.MiscellaneousId, 'M', getValues(`PriceBands.${idx}.PriceBandId`), getValues(`PriceBands.${idx}.Units`), selectedItem.PriceBands, true)))
            .then((results) => {
            let redirect;
            results.forEach((result) => {
                window.dispatchEvent(new CustomEvent('basket.modify', {
                    detail: result,
                }));
                redirect = redirect === undefined ? result.SuccessUrl : redirect;
            });
            if (redirect || localRedirect) {
                window.location.href = redirect ?? localRedirect ?? '';
            }
        })
            .finally(() => {
            setIsSubmitting(false);
        });
    }, [selectedItem, getValues, isSubmitting, setIsSubmitting]);
    return (_jsx(FormProvider, { ...form, children: _jsxs("form", { method: "POST", noValidate: true, onSubmit: handleSubmit, children: [(modalVisible && selectedItem) && (_jsxs(Notice, { onClose: () => setModalVisible(false), children: [_jsx(BandsList, { children: genericBands.map((band, idx) => (_jsx(Band, { band: band, children: _jsx(NumberInput, { name: band.FieldName, bands: genericBands, band: band, price: band.UnitPrice, showPrice: false, accent: "#00AEEF" }) }))) }), _jsx("button", { disabled: !formSubmittable, className: "btn btn--primary btn--full", type: "submit", children: "Add to basket" })] })), _jsx(Wrapper, { className: "rfx-grid rfx-justify-center", children: items.map((item) => (_jsx("div", { className: "rfx-col-lg-4 rfx-col-xs-6 rfx-col-12", children: _jsx(MiscCard, { handleClick: (theItem) => {
                                setSelectedItem(theItem);
                                setModalVisible(true);
                                setValue('MiscellaneousId', theItem.MiscellaneousId);
                                setValue('PriceBands', theItem.PriceBands.map((band) => ({
                                    PriceBandId: band.PriceBandId,
                                    Units: 1,
                                })));
                            }, ...item }) }))) })] }) }));
}
function MiscProducts({ dataset }) {
    const config = useMemo(() => ({
        ...defaultProps,
        ...convertDataAttributes(dataset ?? {}),
    }), [dataset, convertDataAttributes]);
    return (_jsx(Component, { ...config }));
}
export default MiscProducts;
